import {SET_SIDE_OPTION} from "../constants/constants";

export const pushBuildValueSides  = (data) => {
    return {
        type : SET_SIDE_OPTION,
        payload : {...data}
    }
};


// WEBPACK FOOTER //
// ./src/actions/pushBuildValuesSides.js